import React, { forwardRef, Suspense } from "react";
const ReactSelect = React.lazy(() => import("react-select"));
import { components, DropdownIndicatorProps } from "react-select";
import { DropdownProps } from "./Dropdown.types";
import { DropdownWrapper } from "./Dropdown.styles";
import { OptionComponent } from "../Select/RSelectDerived";

const Dropdown = forwardRef<HTMLDivElement, DropdownProps>(
    (props: DropdownProps, ref) => {
        const { onClick, options, toggleNode, externalProps } = props;
        return (
            <Suspense fallback={null}>
                <DropdownWrapper>
                    <ReactSelect
                        {...externalProps}
                        options={options}
                        unstyled
                        isSearchable={false}
                        classNamePrefix={"dropdown"}
                        className="dropdown-main"
                        onChange={(newOption: any) => {
                            newOption?.onClick
                                ? newOption?.onClick(newOption)
                                : onClick?.(newOption);
                        }}
                        components={{
                            DropdownIndicator: ({
                                children,
                                ...localProps
                            }: DropdownIndicatorProps) => {
                                return (
                                    <components.DropdownIndicator
                                        {...localProps}
                                    >
                                        {toggleNode}
                                    </components.DropdownIndicator>
                                );
                            },
                            Option: OptionComponent as any,
                        }}
                        controlShouldRenderValue={false}
                        ref={ref as any}
                        placeholder={""}
                    />
                </DropdownWrapper>
            </Suspense>
        );
    },
);

export default Dropdown;
